import AccessDeniedPage from './AccessDeniedPage';

export default AccessDeniedPage;
